export type PermissionAccessRule = {
  module?: string
  catalogKey?: string
}

/** Должно совпадать с packages/api-service/src/lib/permissions/permission-access.ts */
export const PERMISSION_ACCESS: Record<string, PermissionAccessRule> = {
  access_claims: { module: 'claims' },
  access_claims_works: { module: 'claims' },
  access_claims_requests: { module: 'claims' },
  admin_stageplan_claims: { module: 'claims' },
  access_logistic: { module: 'logistics' },
  logistic_delivery_only: { module: 'logistics' },
  access_hr: { module: 'hr' },
  access_document_templates: { module: 'documents' },
  access_montage: { module: 'montage' },
  access_measurement: { module: 'measurements' },
}

export function isPermissionEnabledForTenant(
  permissionName: string,
  params: { activeModules: string[]; allowedMenuKeys: string[] | null },
): boolean {
  const rule = PERMISSION_ACCESS[permissionName]
  if (!rule) return true
  if (rule.module) return params.activeModules.includes(rule.module)
  if (rule.catalogKey && params.allowedMenuKeys != null) {
    return params.allowedMenuKeys.includes(rule.catalogKey)
  }
  return true
}
